// extracted by mini-css-extract-plugin
export default {"wrap":"iJ-z","heading":"jJ-z","brandPromo":"kJ-z"};